import { fetchRecommendedPropertiesLogic } from './fetchRecommendedPropertiesLogic';
import { trackRecommendedPropertyImpressionsLogic } from './trackRecommendedPropertyImpressionsLogic';

export const logic = [fetchRecommendedPropertiesLogic, trackRecommendedPropertyImpressionsLogic];
